import { useCookies } from "react-cookie";
import CloseButton from "./CloseButton";
import CustomButton from "../../atoms/CustomButton";
import "./styles.scss";

const LogoutModal = ({ width = "400px", onClose, isActive }) => {
  const [, , removeCookies] = useCookies([
    "e_t",
    "eun",
    "euid",
    "vid",
    "ebid",
    "profile",
  ]);
  const cookieNames = ["e_t", "eun", "euid", "vid", "ebid", "ep", "eid", "va"];

  const handleLogout = () => {
    cookieNames.forEach((cookieName) => {
      removeCookies(cookieName, { path: "/" });
    });
  };
  const styles = {
    width: width,
  };
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content" style={styles}>
        <div className="modal-body p-0">
          <div className="p-4 pb-2">
            <p className="modal-heading mb-0">Logout</p>
            <p className="mt-3">Are you sure do you want to Logout?</p>
          </div>

          <div
            className="px-4 py-3 d-flex gap-3 justify-content-end"
            style={{ borderTop: "1px solid #E5E7EB" }}
          >
            <button
              className="btn btn-outline-dark"
              style={{ flex: 1 }}
              onClick={() => onClose()}
            >
              Cancel
            </button>
            {/* Adjust the style for the "Confirm" button */}
            <button
              className="btn btn-primary mt-0"
              onClick={() => handleLogout()}
              style={{ flex: 1 }}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
